/* §8 — „Kas jau yra tavo lentynoje?" realus rekomendavimo įrankis.
   Būsena: mz_owned_full_games_v2. Migracija iš seno mz_owned_products.
   Ta pati būsena naudojama homepage, kataloge, PDP ir cart drawer. */
(function () {
  'use strict';

  var KEY = 'mz_owned_full_games_v2';
  var OLD = 'mz_owned_products';
  var FULL = ['muzikinis-zaidimas', 'muzikinis-zaidimas-x-agata', 'muzikinis-zaidimas-x-kernagis'];

  /* §8.3 tiksli matrica. Raktas — surikiuoti turimi pilni žaidimai. */
  var MATRIX = {
    '': { primary: null, more: [] },
    'muzikinis-zaidimas': {
      primary: 'muzikinis-zaidimas-x-agata',
      why: 'Dar 300 visiškai kitų dainų.',
      more: ['po-dutukstantuju', 'paklausom-is-naujo', 'baltos-kaledos', 'musu-dienos-kaip-svente']
    },
    'muzikinis-zaidimas-x-agata': {
      primary: 'muzikinis-zaidimas',
      why: 'Pirmoji dalis ir platus Lietuvos muzikos istorijos repertuaras.',
      more: ['po-dutukstantuju', 'paklausom-is-naujo', 'baltos-kaledos', 'musu-dienos-kaip-svente']
    },
    'muzikinis-zaidimas-x-kernagis': {
      primary: 'muzikinis-zaidimas-x-agata',
      why: 'Dar 300 kitų dainų ir naujas vakaras.',
      more: ['po-dutukstantuju', 'paklausom-is-naujo', 'baltos-kaledos'],
      note: true
    },
    'muzikinis-zaidimas,muzikinis-zaidimas-x-agata': {
      primary: 'po-dutukstantuju',
      why: 'Daugiau naujesnių hitų jaunesnei kompanijai.',
      more: ['paklausom-is-naujo', 'baltos-kaledos', 'musu-dienos-kaip-svente']
    },
    'muzikinis-zaidimas,muzikinis-zaidimas-x-kernagis': {
      primary: 'muzikinis-zaidimas-x-agata',
      why: 'Dar 300 kitų dainų ir naujas vakaras.',
      more: ['po-dutukstantuju', 'paklausom-is-naujo', 'baltos-kaledos'],
      note: true
    },
    'muzikinis-zaidimas-x-agata,muzikinis-zaidimas-x-kernagis': {
      primary: 'po-dutukstantuju',
      why: 'Daugiau naujesnių hitų jaunesnei kompanijai.',
      more: ['paklausom-is-naujo', 'baltos-kaledos'],
      note: true
    },
    'muzikinis-zaidimas,muzikinis-zaidimas-x-agata,muzikinis-zaidimas-x-kernagis': {
      primary: 'po-dutukstantuju',
      why: 'Daugiau naujesnių hitų jaunesnei kompanijai.',
      more: ['paklausom-is-naujo', 'baltos-kaledos'],
      note: true
    }
  };

  var WHY = {
    'po-dutukstantuju': 'Daugiau dainų, kurias atpažins jaunesni prie stalo.',
    'paklausom-is-naujo': 'Atrankų istorija, dėl kurios visada kyla ginčas.',
    'baltos-kaledos': 'Šventiniam stalui, kuris pradeda dainuoti.',
    'musu-dienos-kaip-svente': 'Vytauto Kernagio kūryba ir kolekcinės kortelės.',
    'muzikinis-zaidimas': 'Pagrindinis žaidimas su plačiausiu repertuaru.',
    'muzikinis-zaidimas-x-agata': '300 kitų dainų ir kitas vakaras.',
    'muzikinis-zaidimas-x-kernagis': 'Kolekcinis leidimas su 350 dainų kortelių.'
  };

  function read() {
    var list = null;
    try { list = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    if (!Array.isArray(list)) {
      /* §8.1 vienkartinė migracija: imame tik tris pilnų žaidimų handle */
      var old = null;
      try { old = JSON.parse(localStorage.getItem(OLD)); } catch (e) {}
      list = Array.isArray(old) ? old.filter(function (h) { return FULL.indexOf(h) !== -1; }) : [];
      write(list, true);
    }
    return list.filter(function (h) { return FULL.indexOf(h) !== -1; });
  }

  function write(list, silent) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    if (!silent) document.dispatchEvent(new CustomEvent('mz:owned', { detail: list }));
  }

  function key(list) {
    return list.slice().sort().join(',');
  }

  function Shelf(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.shelfReady === '1') return;
    root.dataset.shelfReady = '1';

    var items = root.querySelectorAll('[data-shelf-item]');
    var pool = root.querySelector('[data-shelf-pool]');
    var wrap = root.querySelector('[data-shelf-res]');
    var grid = root.querySelector('[data-shelf-grid]');
    
    
    var hint = root.querySelector('[data-shelf-hint]');
    var note = root.querySelector('[data-shelf-note]');
    var reset = root.querySelector('[data-shelf-reset]');
    if (!items.length || !pool) return;

    function card(handle, why) {
      var el = pool.querySelector('[data-shelf-card="' + handle + '"]');
      if (!el) return null;
      var node = el.cloneNode(true);
      var w = node.querySelector('[data-shelf-why]');
      if (w) w.textContent = why || WHY[handle] || '';
      node.hidden = false;
      return node;
    }

    function apply() {
      var owned = [];
      items.forEach(function (i) { if (i.checked) owned.push(i.value); });
      write(owned);

      var m = MATRIX[key(owned)] || MATRIX[''];
      var has = owned.length > 0 && m.primary;

      if (hint) hint.hidden = has;
      if (note) note.hidden = !(m.note);
      if (reset) reset.hidden = owned.length === 0;

      if (grid) grid.innerHTML = '';
      if (wrap) wrap.hidden = !has;
      if (!has) return;

      /* V43 §8 — viena tvarkinga rekomendacijų eilė: [primary, ...more].
         Jau turimi produktai išmetami, dublikatai išmetami,
         išparduoti nukeliauja į galą ir niekada nebūna pirmi, max 3. */
      var order = [m.primary].concat(m.more || []);
      var seen = {};
      order = order.filter(function (h) {
        if (!h || seen[h] || owned.indexOf(h) !== -1) return false;
        seen[h] = 1;
        return true;
      });

      function avail(h) {
        var el = pool.querySelector('[data-shelf-card="' + h + '"]');
        return el && el.dataset.available === '1' ? 0 : 1;
      }
      order.sort(function (a, b) { return avail(a) - avail(b); });
      order = order.slice(0, 3);

      order.forEach(function (h, i) {
        var c = card(h, i === 0 ? m.why : '');
        if (c && grid) grid.appendChild(c);
      });
      if (wrap) wrap.hidden = order.length === 0;
    }

    var saved = read();
    items.forEach(function (i) { i.checked = saved.indexOf(i.value) !== -1; });
    items.forEach(function (i) { i.addEventListener('change', apply); });
    if (reset) reset.addEventListener('click', function () {
      items.forEach(function (i) { i.checked = false; });
      apply();
    });
    apply();

    /* Sinchronizacija tarp komponentų tame pačiame puslapyje */
    document.addEventListener('mz:owned', function (e) {
      var list = e.detail || [];
      items.forEach(function (i) { i.checked = list.indexOf(i.value) !== -1; });
    });
  }

  /* §9.2 — katalogo filtravimas pagal tą patį owned state */
  var SHOW = {
    '': null,
    'muzikinis-zaidimas': ['muzikinis-zaidimas-x-agata','po-dutukstantuju','paklausom-is-naujo','baltos-kaledos','musu-dienos-kaip-svente'],
    'muzikinis-zaidimas-x-agata': ['muzikinis-zaidimas','po-dutukstantuju','paklausom-is-naujo','baltos-kaledos','musu-dienos-kaip-svente'],
    'muzikinis-zaidimas-x-kernagis': ['muzikinis-zaidimas-x-agata','po-dutukstantuju','paklausom-is-naujo','baltos-kaledos'],
    'muzikinis-zaidimas,muzikinis-zaidimas-x-agata': ['po-dutukstantuju','paklausom-is-naujo','baltos-kaledos','musu-dienos-kaip-svente'],
    'muzikinis-zaidimas,muzikinis-zaidimas-x-kernagis': ['muzikinis-zaidimas-x-agata','po-dutukstantuju','paklausom-is-naujo','baltos-kaledos'],
    'muzikinis-zaidimas-x-agata,muzikinis-zaidimas-x-kernagis': ['po-dutukstantuju','paklausom-is-naujo','baltos-kaledos'],
    'muzikinis-zaidimas,muzikinis-zaidimas-x-agata,muzikinis-zaidimas-x-kernagis': ['po-dutukstantuju','paklausom-is-naujo','baltos-kaledos']
  };

  function CatalogFilter(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.catfilterReady === '1') return;
    root.dataset.catfilterReady = '1';

    var showAll = root.querySelector('[data-owned-showall]');
    var ignore = false;

    function handleOf(card) {
      var a = card.querySelector('a[href*="/products/"]');
      if (!a) return '';
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : '';
    }

    function apply() {
      var owned = read();
      var allow = ignore ? null : SHOW[key(owned)];
      var groups = document.querySelectorAll('[data-cat-group]');
      var firstShown = false;
      groups.forEach(function (g) {
        /* V138: rinkiniai priklauso katalogui "Visi" net jei
           lankytojas anksčiau pažymėjo turimą žaidimą. */
        var bundle = g.dataset.catGroup === 'bundle';
        var shown = 0;
        /* Rinkiniai naudoja atskirą .mz-bundle-card markup, ne .pcard. */
        g.querySelectorAll('.pcard, .mz-bundle-card').forEach(function (c) {
          var h = handleOf(c);
          var ok = bundle || !allow || allow.indexOf(h) !== -1;
          /* V53.1 apsauga: jau turimas produktas niekada nerodomas kaip
             rekomendacija, net jei SHOW žemėlapis kada nors išsiderintų. */
          if (!bundle && allow && owned.indexOf(h) !== -1) ok = false;
          /* Kortelės yra tiesioginiai grid vaikai. Slepiame kortelę,
             ne visą grid, kad paskutinė kortelė nepaslėptų visos grupės. */
          c.hidden = !ok;
          if (ok) shown++;
        });
        /* Kategorijų mygtukai lieka autoritetingi — "Rinkiniai"
           rodo tik rinkinius, o "Visi" visada juos įtraukia. */
        var activeCat = document.querySelector('[data-cat-filters] [data-cat].is-active');
        var chosenCat = activeCat ? activeCat.dataset.cat : 'all';
        g.hidden = shown === 0 || (chosenCat !== 'all' && chosenCat !== g.dataset.catGroup);
        var h2 = g.querySelector('h2');
        if (h2) {
          if (!h2.dataset.orig) h2.dataset.orig = h2.textContent.trim();
          if (allow && shown > 0) {
            /* §9.3: pirmoji matoma grupė tampa „REKOMENDUOJAME DABAR",
               visos kitos — „KITI GALIMI PASIRINKIMAI". */
            h2.textContent = firstShown
              ? (root.dataset.labelOther || h2.dataset.orig)
              : (root.dataset.labelNow || h2.dataset.orig);
            firstShown = true;
          } else {
            h2.textContent = h2.dataset.orig;
          }
        }
      });
      if (showAll) showAll.hidden = !allow;
    }

    /* Katalogo filtro checkbox'ai patys užrašo būseną — lentynos sekcija
       gali būti kitoje puslapio vietoje arba jos išvis nebūti. */
    var inputs = root.querySelectorAll('[data-shelf-item]');
    function sync() {
      var saved = read();
      inputs.forEach(function (i) { i.checked = saved.indexOf(i.value) !== -1; });
    }
    inputs.forEach(function (i) {
      i.addEventListener('change', function () {
        var owned = [];
        inputs.forEach(function (x) { if (x.checked) owned.push(x.value); });
        ignore = false;
        write(owned);
        apply();
      });
    });
    sync();

    if (showAll) showAll.addEventListener('click', function () {
      ignore = true; apply(); showAll.hidden = true;
    });
    document.addEventListener('mz:owned', function () { ignore = false; sync(); apply(); });
    apply();
  }

  /* §12 — „Originalas ar AGATA?" CTA: jei vieną jau turi arba jis krepšelyje,
     siūlome tik trūkstamą produktą, ne abu. */
  function CompareCTA(root) {
    /* V73 · PERF-001 — IDEMPOTENT INIT.
       `init()` kviečiamas ir per DOMContentLoaded, ir per
       `shopify:section:load`. Be šios apsaugos tas pats elementas
       theme editoriuje inicializuojamas kartotinai: dubliuojasi
       listeneriai, o kai kur ir tinklo užklausos. Vienas elementas —
       viena inicializacija. */
    if (root.dataset.cmpctaReady === '1') return;
    root.dataset.cmpctaReady = '1';

    var btn = root.querySelector('[data-cmp-bundle]');
    if (!btn) return;
    if (!btn.dataset.bothIds) btn.dataset.bothIds = btn.dataset.addVariant || '';
    if (!btn.dataset.bothLabel) btn.dataset.bothLabel = btn.textContent.trim();

    function apply() {
      var owned = read();
      var a = btn.dataset.handleA, b = btn.dataset.handleB;
      var ids = (btn.dataset.bothIds || '').split(',');
      var hasA = owned.indexOf(a) !== -1;
      var hasB = owned.indexOf(b) !== -1;

      if (hasA && !hasB && ids[1]) {
        btn.dataset.addVariant = ids[1];
        btn.textContent = btn.dataset.labelB || btn.dataset.bothLabel;
      } else if (hasB && !hasA && ids[0]) {
        btn.dataset.addVariant = ids[0];
        btn.textContent = btn.dataset.labelA || btn.dataset.bothLabel;
      } else if (hasA && hasB) {
        btn.hidden = true;
      } else {
        btn.hidden = false;
        btn.dataset.addVariant = btn.dataset.bothIds;
        btn.textContent = btn.dataset.bothLabel;
      }
    }
    document.addEventListener('mz:owned', apply);
    apply();
  }

  /* §13 — cart drawer upsell gerbia owned state */
  /* §11.5 — MŪSŲ DIENOS perspėjimas Kernagio savininkui */
  function KernagisWarn() {
    var el = document.querySelector('[data-kernagis-warn]');
    if (!el) return;
    function apply() {
      el.hidden = read().indexOf('muzikinis-zaidimas-x-kernagis') === -1;
    }
    document.addEventListener('mz:owned', apply);
    apply();
  }

  function CartOwned() {
    function apply() {
      var owned = read();
      document.querySelectorAll('[data-upsell-handle]').forEach(function (el) {
        var h = el.dataset.upsellHandle;
        var hide = owned.indexOf(h) !== -1;
        /* Kernagio savininkui MŪSŲ DIENOS nesiūloma niekada */
        if (h === 'musu-dienos-kaip-svente' &&
            owned.indexOf('muzikinis-zaidimas-x-kernagis') !== -1) hide = true;
        el.hidden = hide;
      });
    }
    document.addEventListener('mz:owned', apply);
    document.addEventListener('mz:cart:updated', apply);
    apply();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cmp-cta]').forEach(function (n) {
      if (n._mzCmp) return;
      n._mzCmp = true;
      CompareCTA(n);
    });
    if (!document._mzCartOwned) { document._mzCartOwned = true; CartOwned(); KernagisWarn(); }
    (scope || document).querySelectorAll('[data-owned-filter]').forEach(function (n) {
      if (n._mzCat) return;
      n._mzCat = true;
      CatalogFilter(n);
    });
    (scope || document).querySelectorAll('[data-shelf]').forEach(function (n) {
      if (n._mzShelf) return;
      n._mzShelf = true;
      Shelf(n);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);

  window.MZOwned = { get: read, set: write, FULL: FULL };
})();
